import { render, staticRenderFns } from "./Embarcacao.vue?vue&type=template&id=6312bb08"
import script from "./Embarcacao.vue?vue&type=script&lang=js"
export * from "./Embarcacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports